import { call, put, select, takeLatest } from 'redux-saga/effects';

import { createActionSetError } from '../../../actions/errorActions';
import { TAction } from '../../../actions/types/action';
import { commonApiServiceAsync } from '../../../services/commonApiService';
import { actions, actionTypes } from './modules';
import { createEventSelector } from './selectors';

function* fetchEventsSaga(action: TAction<any>): any {
  const { ui: eventsUI } = yield select(createEventSelector(action.payload.mode, action.payload.category));

  try {
    if (eventsUI) {
      yield put(
        actions.loadEvents({
          isLoading: true,
          isLoaded: false,
          events: [],
          ui: eventsUI
        })
      );
    }

    const { events, ui } = yield call(commonApiServiceAsync.viewEventsList, {
      mode: action.payload.mode,
      category: action.payload.category
    });

    yield put(
      actions.loadEvents({
        isLoading: false,
        isLoaded: true,
        events: events,
        ui
      })
    );
  } catch (error) {
    yield put(createActionSetError({ body: error.message, type: error.statusCode, title: error.error }));
  }
}

function* watchFetchEvents(): any {
  yield takeLatest(actionTypes.VIEW_EVENTS, fetchEventsSaga);
}

export default [watchFetchEvents()];
